const preventCurrentEvent = (event: Event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
};

export const consumeEvent = (event: Event) => {
  preventCurrentEvent(event);

  window.addEventListener('click', preventCurrentEvent, {
    capture: true,
    once: true
  });
};
